import {
  cn
} from "./chunk-J3MZFSES.js";

// src/components/tooltip.tsx
import { Tooltip as TooltipPrimitive } from "radix-ui";
import { cva } from "class-variance-authority";
import { jsx, jsxs } from "react/jsx-runtime";
function TooltipProvider({ delayDuration = 0, ...props }) {
  return /* @__PURE__ */ jsx(
    TooltipPrimitive.Provider,
    {
      "data-slot": "tooltip-provider",
      delayDuration,
      ...props
    }
  );
}
function Tooltip({ ...props }) {
  return /* @__PURE__ */ jsx(TooltipProvider, { children: /* @__PURE__ */ jsx(
    TooltipPrimitive.Root,
    {
      "data-slot": "tooltip",
      ...props
    }
  ) });
}
function TooltipTrigger({ ...props }) {
  return /* @__PURE__ */ jsx(
    TooltipPrimitive.Trigger,
    {
      "data-slot": "tooltip-trigger",
      ...props
    }
  );
}
var tooltipContentVariants = cva("z-50 size-2", {
  variants: {
    variant: {
      default: "bg-foreground-900 fill-foreground-900 rotate-45 -translate-y-1 rounded-2xs",
      unified: "bg-base-foreground fill-base-foreground rotate-45 !-translate-y-1 rounded-2xs"
    }
  },
  defaultVariants: {
    variant: "default"
  }
});
function TooltipContent({
  className,
  side = "top",
  sideOffset = 0,
  children,
  variant = "default",
  showArrow = true,
  ...props
}) {
  return /* @__PURE__ */ jsx(TooltipPrimitive.Portal, { children: /* @__PURE__ */ jsxs(
    TooltipPrimitive.Content,
    {
      "data-slot": "tooltip-content",
      side,
      sideOffset,
      className: cn(
        "animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 bg-foreground-900 text-foreground-50 text-2xs z-50 w-fit max-w-sm origin-(--radix-tooltip-content-transform-origin) rounded px-2.5 py-1 font-normal tracking-[-0.1px] text-balance",
        className
      ),
      ...props,
      children: [
        children,
        showArrow && /* @__PURE__ */ jsx(TooltipPrimitive.Arrow, { className: cn(tooltipContentVariants({ variant })) })
      ]
    }
  ) });
}

export {
  TooltipProvider,
  Tooltip,
  TooltipTrigger,
  tooltipContentVariants,
  TooltipContent
};
//# sourceMappingURL=chunk-WXXM7AFR.js.map